(() => {
  if (customElements.get('section-slider-images')) {
    return;
  }

  class SectionSliderImages extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.observer = null;
      this.checkMobileSticky = this.checkMobileSticky.bind(this);
      this.scrollProgress = 0;
      this.currentSlideIndex = 0;
      this.mobileBreakpoint = '(max-width: 1023px)';
      this.sliderType = '';
      this.enabledMobileParallax = this.hasAttribute('data-mobile-parallax');
    }

    connectedCallback() {
      // Small delay to ensure Swiper is loaded
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initSlider(), 100);
      } else {
        this.initSlider();

        if (this.enabledMobileParallax) {
          this.checkMobileSticky();
        }
      }

      this.attachEvents();
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
      }
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    attachEvents() {
      if (this.enabledMobileParallax) {
        this.debouncedOnResize = debounce(() => {
          const isMobileDevices = window.matchMedia(
            this.mobileBreakpoint,
          ).matches;

          if (
            (isMobileDevices && this.sliderType === 'mobile') ||
            (!isMobileDevices && this.sliderType === 'desktop')
          ) {
            return;
          }

          this.destroySlider();

          this.initSlider();
        }, 100);

        window.addEventListener('resize', this.debouncedOnResize.bind(this));
        window.addEventListener('resize', this.checkMobileSticky);
        window.addEventListener('scroll', this.checkMobileSticky);
      }
    }

    initSlider() {
      if (!this.querySelector('[data-slider]') && this.slider !== null) return;

      // Make sure Swiper is loaded
      if (typeof Swiper === 'undefined') {
        console.warn('Swiper is not loaded yet');
        return;
      }

      const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

      this.options = {
        loop: true,
        centeredSlides: false,
        slidesPerView: 3,
        navigation: {
          prevEl: this.querySelector('.slider-prev'),
          nextEl: this.querySelector('.slider-next'),
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          1023: {
            slidesPerView: 3,
          }
        },
      };

      if (this.enabledMobileParallax) {
        this.options = {
          centeredSlides: false,
          slidesPerView: 1,
          allowTouchMove: false,
          breakpoints: {
            1023: {
              slidesPerView: 3,
              allowTouchMove: true,
              navigation: {
                prevEl: this.querySelector('.slider-prev'),
                nextEl: this.querySelector('.slider-next'),
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            }
          },
        };

        if (isMobileDevices) {
          this.options.effect = 'fade';
          this.options.fadeEffect = {
            crossFade: true
          };
        }

        this.options.loop = isMobileDevices ? false : true;
        this.sliderType = isMobileDevices ? 'mobile' : 'desktop';
      }

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.options);
    }

    checkMobileSticky() {
      const isMobile = window.matchMedia(this.mobileBreakpoint).matches;

      if (!isMobile) {
        this.currentSlideIndex = 0;
        this.scrollProgress = 0;

        return;
      }

      const sliderElement = this.querySelector('[data-slider]');
      const topOffset = parseFloat(getComputedStyle(sliderElement).top || 0);
      const scrollTop = window.scrollY;
      const sectionTop = this.offsetTop;
      const sectionHeight = this.offsetHeight;
      const swiperHeight = sliderElement.offsetHeight;
      const startStick = sectionTop - topOffset;
      const endStick = sectionTop + sectionHeight - swiperHeight - topOffset;

      let progress = (scrollTop - startStick) / (endStick - startStick);

      this.scrollProgress = Math.min(Math.max(progress, 0), 1);

      this.changeSlide();
    }

    changeSlide() {
      if (!this.slider) {
        return;
      }

      const totalSlides = this.slider.slides.length;
      const step = 1 / totalSlides;

      const activeIndex = Math.min(Math.floor(this.scrollProgress / step), totalSlides - 1);

      if (activeIndex === this.currentSlideIndex) {
        return;
      }

      this.currentSlideIndex = activeIndex;

      this.slider.slideTo(activeIndex);
    }

    destroySlider() {
      this.slider.destroy();

      this.slider = null;
    }
  }

  customElements.define('section-slider-images', SectionSliderImages);
})();
